import React, { useState, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import { useTheme, alpha } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { jwtDecode } from "jwt-decode";
import { DataGrid } from "@mui/x-data-grid";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Collapse from "@mui/material/Collapse";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
/* import CustomerForm from "./CustomerForm"; */

import { useTranslation } from "react-i18next";

import CustomerForm from "./CustomerForm";

import IconButton from "@mui/material/IconButton";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import Avatar from "@mui/material/Avatar";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import Tooltip from "@mui/material/Tooltip";
import { DatePicker } from "@mui/lab";
import ExcelUpload from "./ExcelUpload";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Add } from "@mui/icons-material";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";

import LogoABC from "../../img/ventas/abc.png";
import {
  pageContentCardSx,
  pageDataGridSx,
  pageFieldSx,
  pageHeroShellSx,
  pageMobileCardSx,
} from "../../styles/pageModernStyles";
import { customerMatchesSearch } from "./customerSearchUtils";

const useStyles = makeStyles(() => ({
  avatarA: {
    backgroundColor: "rgb(0, 194, 163)",
    "&.MuiAvatar-circular": {
      backgroundColor: "transparent",
      color: "rgb(0, 194, 163)",
      border: "2px solid rgb(0, 194, 163)",
      fontWeight: "800",
      fontSize: "14px",
      width: "30px",
      height: "30px",
    },
  },
  avatarB: {
    backgroundColor: "rgb(0, 194, 163)",
    "&.MuiAvatar-circular": {
      backgroundColor: "transparent",
      color: "rgb(0, 194, 163)",
      border: "2px solid rgb(0, 194, 163)",
      fontWeight: "800",
      fontSize: "14px",
      width: "30px",
      height: "30px",
    },
  },
  avatarC: {
    backgroundColor: "#ffac7e",
    "&.MuiAvatar-circular": {
      backgroundColor: "transparent",
      color: "#ffac7e",
      border: "2px solid #ffac7e",
      fontWeight: "800",
      fontSize: "14px",
      width: "30px",
      height: "30px",
    },
  },
  avatarD: {
    backgroundColor: "rgb(0, 194, 163)",
    "&.MuiAvatar-circular": {
      backgroundColor: "transparent",
      color: "rgb(0, 194, 163)",
      border: "2px solid rgb(0, 194, 163)",
      fontWeight: "800",
      fontSize: "14px",
      width: "30px",
      height: "30px",
    },
  },
  avatarE: {
    backgroundColor: "#ffac7e",
    "&.MuiAvatar-circular": {
      backgroundColor: "transparent",
      color: "#ffac7e",
      border: "2px solid #ffac7e",
      fontWeight: "800",
      fontSize: "14px",
      width: "30px",
      height: "30px",
    },
  },
  avatarF: {
    backgroundColor: "red",
    "&.MuiAvatar-circular": {
      backgroundColor: "transparent",
      color: "red",
      border: "2px solid red",
      fontWeight: "800",
      fontSize: "14px",
      width: "30px",
      height: "30px",
    },
  },
  avatarG: {
    backgroundColor: "rgb(0, 194, 163)",
    "&.MuiAvatar-circular": {
      backgroundColor: "transparent",
      color: "rgb(0, 194, 163)",
      border: "2px solid rgb(0, 194, 163)",
      fontWeight: "800",
      fontSize: "14px",
      width: "30px",
      height: "30px",
    },
  },
  avatarH: {
    backgroundColor: "red",
    "&.MuiAvatar-circular": {
      backgroundColor: "transparent",
      color: "red",
      border: "2px solid red",
      fontWeight: "800",
      fontSize: "14px",
      width: "30px",
      height: "30px",
    },
  },
  avatarI: {
    backgroundColor: "red",
    "&.MuiAvatar-circular": {
      backgroundColor: "transparent",
      color: "red",
      border: "2px solid red",
      fontWeight: "800",
      fontSize: "14px",
      width: "30px",
      height: "30px",
    },
  },
  avatarJ: {
    backgroundColor: "#3174ad",
    "&.MuiAvatar-circular": {
      backgroundColor: "transparent",
      color: "red",
      border: "2px solid red",
      fontWeight: "800",
      fontSize: "14px",
      width: "30px",
      height: "30px",
    },
  },
  avatarVacio: {
    backgroundColor: "red",
    "&.MuiAvatar-circular": {
      backgroundColor: "transparent",
      color: "#ff000038",
      border: "2px solid #ff000038",
      fontWeight: "800",
      fontSize: "14px",
      width: "30px",
      height: "30px",
    },
  },
}));

const responsables = [
  "Irene",
  "Lydia",
  "Imma",
  "Sara",
  "Agustina",
  "Laura",
  "Chiara",
  "Alex",
  "Borja",
  "Miguel",
  "Mikael",
];

const estados = [
  "New",
  "Ok Financiero",
  "Estudio Cliente",
  "Contactando",
  "Pain Presentación",
  "Muestra Interés",
  "En el Ring",
  "Esperando decisión",
  "Ganado",
  "Perdido",
  "Inactivo",
];

const procedencias = ["Aotai", "HS Fashion", "No Man's Label", "Stage"];

const CustomerList = ({ customers, onAdd, onEdit, onDelete }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { i18n, t } = useTranslation();
  const accent = theme.palette.primary.main;
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [currentCustomerId, setCurrentCustomerId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedResponsables, setSelectedResponsables] = useState([]);
  const [selectedEstados, setSelectedEstados] = useState([]);
  const [selectedProcedencia, setSelectedProcedencia] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedABC, setSelectedABC] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [customerToDelete, setCustomerToDelete] = useState(null);
  const [userId, setUserId] = useState(null);
  const [selectedDaysWithoutShipping, setSelectedDaysWithoutShipping] =
    useState("");

  const [showPreview, setShowPreview] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const handleMouseEnter = (event) => {
    setShowPreview(true);
    setMousePosition({
      x: event.clientX,
      y: event.clientY,
    });
  };

  const handleMouseMove = (event) => {
    setMousePosition({
      x: event.clientX,
      y: event.clientY,
    });
  };

  const handleMouseLeave = () => {
    setShowPreview(false);
  };

  useEffect(() => {
    // Obtener el token desde el almacenamiento local
    const token = localStorage.getItem("token");
    if (token) {
      try {
        // Decodificar el token para obtener la información del usuario
        const decodedToken = jwtDecode(token);
        setUserId(decodedToken.userId); // Asegúrate de usar el campo correcto del token decodificado
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);

  // Verifica si el usuario tiene permiso para eliminar (no es el ID 10 ni el 11)
  const canDelete = () => {
    // Lista de IDs restringidos
    const restrictedIds = [10, 11];
    return !restrictedIds.includes(userId);
  };

  const handleEdit = (id) => {
    setCurrentCustomerId(id);
    setDrawerOpen(true);
  };

  const handleAdd = () => {
    setCurrentCustomerId(null);
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    setCurrentCustomerId(null);
  };

  const handleFormSubmit = async (customer) => {
    if (currentCustomerId) {
      await onEdit(currentCustomerId, customer);
    } else {
      await onAdd(customer);
    }
    handleDrawerClose();
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleDeleteClick = (id) => {
    if (canDelete()) {
      setCustomerToDelete(id);
      setOpenDialog(true);
    } else {
      alert("You do not have permission to delete this customer.");
    }
  };

  const handleConfirmDelete = async () => {
    await onDelete(customerToDelete);
    setOpenDialog(false);
    setCustomerToDelete(null);
  };

  const handleCancelDelete = () => {
    setOpenDialog(false);
    setCustomerToDelete(null);
  };

  const filterCustomers = (customers) => {
    return customers.filter((customer) => {
      const matchesSearch = customerMatchesSearch(customer, searchTerm);

      const matchesResponsables =
        selectedResponsables.length === 0 ||
        selectedResponsables.includes(customer.responsableVentas);

      const matchesEstados =
        selectedEstados.length === 0 ||
        selectedEstados.includes(customer.estado);

      const matchesProcedencia =
        selectedProcedencia.length === 0 ||
        selectedProcedencia.includes(customer.procedencia);

      const matchesDate =
        !selectedDate ||
        new Date(customer.fecha_creacion).toLocaleDateString("es-ES") ===
          selectedDate.toLocaleDateString("es-ES");

      const matchesABC =
        selectedABC.length === 0 || selectedABC.includes(customer.abc);

      return (
        matchesSearch &&
        matchesResponsables &&
        matchesEstados &&
        matchesProcedencia &&
        matchesDate &&
        matchesABC
      );
    });
  };

  const getAvatarClass = (abc) => {
    switch (abc) {
      case "AA":
        return classes.avatarA;
      case "AB":
        return classes.avatarB;
      case "AC":
        return classes.avatarC;

      case "BA":
        return classes.avatarD;
      case "BB":
        return classes.avatarE;
      case "BC":
        return classes.avatarF;
      case "CA":
        return classes.avatarG;
      case "CB":
        return classes.avatarH;
      case "CC":
        return classes.avatarI;

      default:
        return classes.avatarVacio;
    }
  };

  const getTipeClienteClass = (tipo_cliente) => {
    switch (tipo_cliente) {
      case "Particular":
        return classes.avatarA;
      case "Empresa":
        return classes.avatarB;
      default:
        return classes.avatarVacio;
    }
  };

  const filteredCustomers = filterCustomers(customers);

  const sortedCustomers = useMemo(
    () =>
      [...filteredCustomers].sort((a, b) =>
        (a.name || "").localeCompare(b.name || "", "es", {
          sensitivity: "base",
        }),
      ),
    [filteredCustomers],
  );

  const activeFilterCount = useMemo(() => {
    let count = 0;
    if (selectedResponsables.length) count += 1;
    if (selectedEstados.length) count += 1;
    if (selectedProcedencia.length) count += 1;
    if (selectedABC.length) count += 1;
    if (selectedDate) count += 1;
    if (selectedDaysWithoutShipping) count += 1;
    return count;
  }, [
    selectedResponsables,
    selectedEstados,
    selectedProcedencia,
    selectedABC,
    selectedDate,
    selectedDaysWithoutShipping,
  ]);

  const formatCreatedDate = (value) => {
    if (!value) return "—";
    const date = new Date(value);
    return date.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const getEstadoChipSx = (estado) => {
    const won = estado === "Ganado";
    const lost = estado === "Perdido" || estado === "Inactivo";
    const active =
      estado === "Contactando" ||
      estado === "Muestra Interés" ||
      estado === "En el Ring";
    const color = won
      ? theme.palette.success.main
      : lost
        ? theme.palette.error.main
        : active
          ? theme.palette.warning.main
          : theme.palette.info.main;
    return {
      height: 24,
      fontWeight: 700,
      fontSize: "0.7rem",
      bgcolor: alpha(color, 0.1),
      color,
      border: "1px solid",
      borderColor: alpha(color, 0.28),
      maxWidth: "100%",
      "& .MuiChip-label": { px: 0.75 },
    };
  };

  const desktopGridSx = {
    height: "min(72vh, calc(100dvh - 300px))",
    width: "100%",
    border: "none",
    borderRadius: 0,
    bgcolor: "transparent",
    ...pageDataGridSx(theme),
    "& .MuiDataGrid-columnHeaders": {
      borderBottom: `1px solid ${alpha(theme.palette.divider, 0.9)}`,
      bgcolor: alpha(theme.palette.primary.main, 0.05),
      minHeight: "44px !important",
      maxHeight: "44px !important",
    },
    "& .MuiDataGrid-columnHeader": {
      fontWeight: 800,
      px: 1.5,
      display: "flex",
      alignItems: "center",
    },
    "& .MuiDataGrid-columnHeader[data-field='name'] .MuiDataGrid-columnHeaderTitleContainer":
      {
        justifyContent: "flex-start",
      },
    "& .MuiDataGrid-columnHeader[data-field='email'] .MuiDataGrid-columnHeaderTitleContainer, & .MuiDataGrid-columnHeader[data-field='observaciones'] .MuiDataGrid-columnHeaderTitleContainer":
      {
        justifyContent: "flex-start",
      },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 800,
      fontSize: "0.68rem",
      letterSpacing: 0.45,
    },
    "& .MuiDataGrid-row": {
      cursor: "pointer",
      transition: "background-color 0.15s ease",
      "&:hover": {
        bgcolor: `${alpha(theme.palette.primary.main, 0.07)} !important`,
      },
    },
    "& .MuiDataGrid-row:nth-of-type(even)": {
      bgcolor: alpha(theme.palette.background.default, 0.45),
    },
    "& .MuiDataGrid-cell": {
      display: "flex",
      alignItems: "center",
      fontSize: "0.84rem",
      lineHeight: 1.35,
      py: 0,
    },
    "& .MuiDataGrid-cellContent": {
      display: "flex",
      alignItems: "center",
      width: "100%",
      minWidth: 0,
      height: "100%",
      overflow: "hidden",
      lineHeight: 1.35,
    },
    "& .MuiDataGrid-cell[data-field='abc'], & .MuiDataGrid-cell[data-field='actions']":
      {
        justifyContent: "center",
      },
    "& .MuiDataGrid-cell[data-field='abc'] .MuiDataGrid-cellContent, & .MuiDataGrid-cell[data-field='actions'] .MuiDataGrid-cellContent":
      {
        justifyContent: "center",
      },
    "& .MuiDataGrid-cellContent .MuiTypography-root": {
      margin: 0,
      lineHeight: 1.35,
    },
    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
      outline: "none",
    },
    "& .MuiDataGrid-footerContainer": {
      borderTop: `1px solid ${alpha(theme.palette.divider, 0.85)}`,
      bgcolor: alpha(theme.palette.background.default, 0.35),
      minHeight: 48,
    },
  };

  const renderMobileCustomerCard = (customer) => (
    <Box
      key={customer.id}
      onClick={() => handleEdit(customer.id)}
      sx={{
        ...pageMobileCardSx(theme, { accentColor: accent }),
        cursor: "pointer",
      }}
    >
      <Stack direction="row" spacing={1.25} alignItems="flex-start">
        <Avatar className={getAvatarClass(customer.abc)} sx={{ mt: 0.25 }}>
          {customer.abc || "?"}
        </Avatar>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Stack
            direction="row"
            alignItems="flex-start"
            justifyContent="space-between"
            spacing={1}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 800, lineHeight: 1.25 }}>
                {customer.name || "—"}
              </Typography>
              {customer.city ? (
                <Typography variant="caption" color="text.secondary">
                  {customer.city}
                </Typography>
              ) : null}
            </Box>
            <IconButton
              aria-label="delete"
              size="small"
              disabled={!canDelete()}
              onClick={(event) => {
                event.stopPropagation();
                handleDeleteClick(customer.id);
              }}
              sx={{
                border: "1.5px solid",
                borderColor: "error.main",
                flexShrink: 0,
              }}
            >
              <DeleteOutlineOutlinedIcon sx={{ color: "error.main", fontSize: 18 }} />
            </IconButton>
          </Stack>

          <Stack
            direction="row"
            spacing={0.5}
            useFlexGap
            flexWrap="wrap"
            sx={{ mt: 0.75 }}
          >
            {customer.estado ? (
              <Chip
                label={t(`Clientes.${customer.estado}`, { defaultValue: customer.estado })}
                size="small"
                sx={{ height: 22, fontWeight: 700, fontSize: "0.68rem" }}
              />
            ) : null}
            {customer.responsableVentas ? (
              <Chip
                label={customer.responsableVentas}
                size="small"
                variant="outlined"
                sx={{ height: 22, fontWeight: 600, fontSize: "0.68rem" }}
              />
            ) : null}
            <Chip
              label={formatCreatedDate(customer.fecha_creacion)}
              size="small"
              sx={{
                height: 22,
                fontWeight: 600,
                fontSize: "0.68rem",
                bgcolor: alpha(accent, 0.08),
              }}
            />
          </Stack>

          {customer.email ? (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{
                display: "block",
                mt: 0.75,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {customer.email}
            </Typography>
          ) : null}

          {customer.phone ? (
            <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
              {customer.phone}
            </Typography>
          ) : null}

          {customer.observaciones ? (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{
                display: "block",
                mt: 0.5,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {customer.observaciones}
            </Typography>
          ) : null}
        </Box>
      </Stack>
    </Box>
  );

  const columns = [
    {
      field: "name",
      headerName: t("Clientes.Client"),
      flex: 1,
      minWidth: 148,
      filterable: true,
      sortable: true,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <Box
          title={params.value || ""}
          sx={{
            width: "100%",
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontWeight: 800,
            fontSize: "0.86rem",
            lineHeight: 1.35,
          }}
        >
          {params.value || "—"}
        </Box>
      ),
    },
    {
      field: "estado",
      headerName: t("Clientes.statement"),
      width: 132,
      filterable: true,
      renderCell: (params) =>
        params.value ? (
          <Chip
            size="small"
            label={t(`Clientes.${params.value}`, {
              defaultValue: params.value,
            })}
            sx={getEstadoChipSx(params.value)}
          />
        ) : (
          "—"
        ),
    },
    {
      field: "abc",
      headerName: t("Clientes.ABC"),
      width: 64,
      align: "center",
      headerAlign: "center",
      filterable: true,
      renderCell: (params) => (
        <Avatar
          className={getAvatarClass(params.value)}
          sx={{ width: 34, height: 34, m: 0 }}
        >
          {params.value}
        </Avatar>
      ),
    },
    {
      field: "city",
      headerName: t("Clientes.City"),
      width: 112,
      filterable: true,
      renderCell: (params) => (
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.82rem" }}>
          {params.value || "—"}
        </Typography>
      ),
    },
    {
      field: "phone",
      headerName: t("Clientes.Phone"),
      width: 118,
      filterable: true,
      renderCell: (params) => (
        <Typography
          variant="body2"
          sx={{ fontVariantNumeric: "tabular-nums", fontSize: "0.82rem" }}
        >
          {params.value || "—"}
        </Typography>
      ),
    },
    {
      field: "email",
      headerName: t("Clientes.Email"),
      flex: 1,
      minWidth: 180,
      filterable: true,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <Tooltip title={params.value || ""}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontSize: "0.82rem",
            }}
          >
            {params.value || "—"}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "observaciones",
      headerName: t("Clientes.observations"),
      flex: 1,
      minWidth: 160,
      filterable: true,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => {
        const observaciones = params.value;
        if (!observaciones) return "—";
        return (
          <Tooltip title={observaciones}>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontSize: "0.8rem",
                fontStyle: "italic",
              }}
            >
              {observaciones}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "responsableVentas",
      headerName: t("Clientes.AccManager"),
      width: 128,
      filterable: true,
      renderCell: (params) =>
        params.value ? (
          <Chip
            label={params.value}
            size="small"
            sx={{
              height: 24,
              fontWeight: 700,
              fontSize: "0.72rem",
              bgcolor: alpha(accent, 0.09),
              color: theme.palette.primary.dark,
              border: "1px solid",
              borderColor: alpha(accent, 0.18),
            }}
          />
        ) : (
          "—"
        ),
    },
    {
      field: "actions",
      headerName: t("Clientes.Actions"),
      width: 72,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <IconButton
          aria-label="delete"
          size="small"
          onClick={(event) => {
            event.stopPropagation();
            handleDeleteClick(params.row.id);
          }}
          disabled={!canDelete()}
          sx={{
            border: "1.5px solid",
            borderColor: alpha(theme.palette.error.main, 0.45),
            bgcolor: alpha(theme.palette.error.main, 0.04),
            width: 34,
            height: 34,
            "&:hover": {
              bgcolor: alpha(theme.palette.error.main, 0.12),
              borderColor: "error.main",
            },
          }}
        >
          <DeleteOutlineOutlinedIcon sx={{ color: "error.main", fontSize: 18 }} />
        </IconButton>
      ),
    },
  ];

  const filterSurfaceBg =
    theme.palette.mode === "dark"
      ? theme.palette.background.cajaInpunts ||
        alpha(theme.palette.common.black, 0.35)
      : theme.palette.caja?.main || theme.palette.background.paper;

  const filterInputSx = {
    width: { xs: "100%", sm: 148, md: 156 },
    minWidth: 0,
    ...pageFieldSx(theme),
    "& .MuiInputBase-root": {
      ...pageFieldSx(theme)["& .MuiInputBase-root"],
      backgroundColor: filterSurfaceBg,
      color: theme.palette.text.primary,
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary,
    },
    "& .MuiSelect-icon, & .MuiSvgIcon-root": {
      color: theme.palette.text.secondary,
    },
  };

  const searchFieldSx = {
    ...filterInputSx,
    width: { xs: "100%", sm: 280, md: 320 },
  };

  const toolbarIconSx = {
    color: "primary.main",
    border: "1px solid",
    borderColor: "primary.main",
    "&.MuiIconButton-root": { height: "2.25rem", width: "2.25rem" },
    "&:hover": {
      backgroundColor: "primary.main",
      color: "primary.contrastText",
    },
  };

  const renderFilters = () => (
    <>
      <FormControl variant="outlined" size="small" sx={filterInputSx}>
        <InputLabel>{t("Clientes.AccManager")}</InputLabel>
        <Select
          multiple
          value={selectedResponsables}
          onChange={(e) => setSelectedResponsables(e.target.value)}
          label={t("Clientes.AccManager")}
          renderValue={(selected) => selected.join(", ")}
        >
          {responsables.map((responsable) => (
            <MenuItem key={responsable} value={responsable}>
              <Checkbox
                checked={selectedResponsables.indexOf(responsable) > -1}
              />
              <ListItemText primary={responsable} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small" sx={filterInputSx}>
        <InputLabel>{t("Clientes.Origin")}</InputLabel>
        <Select
          multiple
          value={selectedProcedencia}
          onChange={(e) => setSelectedProcedencia(e.target.value)}
          label={t("Clientes.Origin")}
          renderValue={(selected) => selected.join(", ")}
        >
          {procedencias.map((procedencia) => (
            <MenuItem key={procedencia} value={procedencia}>
              <Checkbox
                checked={selectedProcedencia.indexOf(procedencia) > -1}
              />
              <ListItemText primary={procedencia} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small" sx={filterInputSx}>
        <InputLabel>{t("Clientes.statement")}</InputLabel>
        <Select
          multiple
          value={selectedEstados}
          onChange={(e) => setSelectedEstados(e.target.value)}
          label={t("Clientes.statement")}
          renderValue={(selected) =>
            selected.map((estado) => t(`Clientes.${estado}`)).join(", ")
          }
        >
          {estados.map((estado) => (
            <MenuItem key={estado} value={estado}>
              <Checkbox checked={selectedEstados.indexOf(estado) > -1} />
              <ListItemText primary={t(`Clientes.${estado}`)} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small" sx={filterInputSx}>
        <InputLabel>{t("Clientes.ABC")}</InputLabel>
        <Select
          multiple
          value={selectedABC}
          onChange={(e) => setSelectedABC(e.target.value)}
          label={t("Clientes.ABC")}
          renderValue={(selected) => selected.join(", ")}
        >
          {["AA", "AB", "AC", "BA", "BB", "BC", "CA", "CB", "CC"].map(
            (abc) => (
              <MenuItem key={abc} value={abc}>
                <Checkbox checked={selectedABC.indexOf(abc) > -1} />
                <ListItemText primary={abc} />
              </MenuItem>
            ),
          )}
        </Select>
      </FormControl>
      <DatePicker
        label={t("Clientes.createdAtFilter")}
        value={selectedDate}
        onChange={(date) => setSelectedDate(date)}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            sx={{ ...filterInputSx, width: { xs: "100%", sm: 168 } }}
          />
        )}
      />
    </>
  );

  return (
    <>
      <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <Box sx={pageHeroShellSx(theme, { sticky: !isMobile })}>
          <Box sx={{ p: { xs: 1.25, sm: 1.75 } }}>
            <Stack
              direction={{ xs: "column", lg: "row" }}
              justifyContent="space-between"
              alignItems={{ xs: "stretch", lg: "flex-start" }}
              spacing={1.5}
            >
              <Stack direction="row" spacing={1.25} alignItems="flex-start">
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: alpha(accent, 0.16),
                    color: theme.palette.primary.dark,
                    border: "1px solid",
                    borderColor: alpha(accent, 0.28),
                  }}
                >
                  <GroupsOutlinedIcon fontSize="small" />
                </Box>
                <Box>
                  <Typography
                    variant="overline"
                    color="text.secondary"
                    sx={{ fontWeight: 700, letterSpacing: 1.1 }}
                  >
                    CRM
                  </Typography>
                  <Typography
                    variant={isMobile ? "h5" : "h4"}
                    sx={{ fontWeight: 800, lineHeight: 1.1 }}
                  >
                    {t("sidebar.clients")}
                  </Typography>
                  <Chip
                    size="small"
                    label={`${filteredCustomers.length} ${t("sidebar.clients").toLowerCase()}`}
                    sx={{
                      mt: 0.75,
                      fontWeight: 700,
                      bgcolor: alpha(accent, 0.1),
                      color: theme.palette.primary.dark,
                    }}
                  />
                </Box>
              </Stack>

              <Stack
                spacing={1}
                alignItems={{ xs: "stretch", lg: "flex-end" }}
                sx={{ width: { xs: "100%", lg: "auto" }, minWidth: 0 }}
              >
                <Stack
                  direction="row"
                  spacing={1}
                  flexWrap="wrap"
                  useFlexGap
                  alignItems="center"
                  justifyContent={{ xs: "flex-start", lg: "flex-end" }}
                  sx={{ width: "100%" }}
                >
                  <TextField
                    label={t("Clientes.search")}
                    variant="outlined"
                    size="small"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    sx={searchFieldSx}
                  />
                  {isMobile ? (
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<FilterListOutlinedIcon />}
                      onClick={() => setFiltersOpen((open) => !open)}
                      sx={{ fontWeight: 700, textTransform: "none" }}
                    >
                      {t("Clientes.filters", { defaultValue: "Filtros" })}
                      {activeFilterCount > 0 ? ` (${activeFilterCount})` : ""}
                    </Button>
                  ) : null}
                  <Tooltip title={t("Clientes.addCustomerTooltip")}>
                    <IconButton
                      onClick={handleAdd}
                      aria-label="add-client"
                      size="medium"
                      sx={toolbarIconSx}
                    >
                      <Add />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("Clientes.abcPreviewTooltip")}>
                    <IconButton
                      aria-label="abc-legend"
                      size="medium"
                      sx={{
                        ...toolbarIconSx,
                        borderColor: "secondary.main",
                        color: "secondary.main",
                        "&:hover": {
                          backgroundColor: "secondary.main",
                          color: "secondary.contrastText",
                        },
                      }}
                      onMouseEnter={handleMouseEnter}
                      onMouseMove={handleMouseMove}
                      onMouseLeave={handleMouseLeave}
                    >
                      <Box
                        component="img"
                        src={LogoABC}
                        alt="Logo ABC"
                        sx={{ height: ".85em", width: "1em", objectFit: "cover" }}
                      />
                    </IconButton>
                  </Tooltip>
                  <ExcelUpload />
                </Stack>

                {isMobile ? (
                  <Collapse in={filtersOpen}>
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 1.25,
                        alignItems: "center",
                      }}
                    >
                      {renderFilters()}
                    </Box>
                  </Collapse>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1,
                      alignItems: "center",
                      justifyContent: "flex-end",
                      width: "100%",
                      maxWidth: { lg: 720 },
                    }}
                  >
                    {renderFilters()}
                  </Box>
                )}
              </Stack>
            </Stack>

            {showPreview &&
              createPortal(
                <Box
                  component="img"
                  src={LogoABC}
                  alt="Preview"
                  sx={{
                    position: "fixed",
                    top: mousePosition.y + 10,
                    left: Math.max(8, mousePosition.x - (isMobile ? 200 : 500)),
                    width: isMobile ? "min(92vw, 360px)" : "450px",
                    height: isMobile ? "auto" : "300px",
                    maxWidth: "92vw",
                    objectFit: "cover",
                    backgroundColor: theme.palette.background.paper,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                    boxShadow:
                      theme.palette.mode === "dark"
                        ? "0 8px 24px rgba(0,0,0,0.45)"
                        : "0 8px 24px rgba(0,0,0,0.12)",
                    zIndex: 1500,
                    pointerEvents: "none",
                  }}
                />,
                document.body,
              )}
          </Box>
        </Box>

        {isMobile ? (
          <Stack spacing={1.25} sx={{ pb: 1 }}>
            {filteredCustomers.length === 0 ? (
              <Box
                sx={{
                  py: 6,
                  textAlign: "center",
                  borderRadius: 3,
                  border: "1px dashed",
                  borderColor: "divider",
                }}
              >
                <Typography color="text.secondary">
                  {t("Clientes.noResults", { defaultValue: "No hay clientes con estos filtros." })}
                </Typography>
              </Box>
            ) : (
              sortedCustomers.map((customer) => renderMobileCustomerCard(customer))
            )}
          </Stack>
        ) : (
          <Box
            sx={{
              ...pageContentCardSx(theme, accent),
              p: 0,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                px: 2,
                py: 1.25,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                borderBottom: "1px solid",
                borderColor: alpha(theme.palette.divider, 0.75),
                bgcolor: alpha(theme.palette.primary.main, 0.03),
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
                {filteredCustomers.length}{" "}
                {filteredCustomers.length === 1
                  ? t("Clientes.result", { defaultValue: "cliente" })
                  : t("sidebar.clients").toLowerCase()}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                {t("Clientes.clickRowHint", {
                  defaultValue: "Clic en fila para editar",
                })}
              </Typography>
            </Box>
            <DataGrid
              rows={sortedCustomers}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10, 25, 50]}
              rowHeight={52}
              disableSelectionOnClick
              disableColumnMenu
              initialState={{
                sorting: {
                  sortModel: [{ field: "name", sort: "asc" }],
                },
              }}
              onRowClick={(params) => handleEdit(params.row.id)}
              sx={desktopGridSx}
            />
          </Box>
        )}
      </Box>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerClose}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 16,
            borderBottomLeftRadius: 16,
            border: "1px solid",
            borderColor: alpha(theme.palette.divider, 0.75),
            maxWidth: "100vw",
            boxShadow: `0 24px 64px ${alpha(theme.palette.common.black, 0.16)}`,
            bgcolor: theme.palette.background.default,
          },
        }}
      >
        <Box
          sx={{
            width: { xs: "100vw", sm: "100vw", md: 1000, lg: 1830 },
            maxWidth: "100vw",
            p: 0,
            minHeight: { xs: "100dvh", md: "auto" },
          }}
        >
          <CustomerForm
            customerId={currentCustomerId}
            onSubmit={handleFormSubmit}
            onClose={handleDrawerClose}
          />
        </Box>
      </Drawer>
      <Dialog
        open={openDialog}
        onClose={handleCancelDelete}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ fontWeight: 800, color: "error.main" }}
        >
          {t("Clientes.deleteConfirmTitle")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("Clientes.deleteConfirmBody")}
            <br />
            <br />
            <Box component="span" sx={{ fontWeight: 800 }}>
              {t("Clientes.deleteConfirmWarning")}
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <Button onClick={handleCancelDelete} color="inherit" variant="outlined">
            {t("Clientes.cancel")}
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
            autoFocus
          >
            {t("Clientes.delete")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CustomerList;
